import React, { useEffect, useRef, useState } from 'react';
import { PageLoading } from '@ant-design/pro-layout';
import { setLocale, useModel } from 'umi';
import type { ConnectProps } from 'umi';
import { Redirect, connect } from 'umi';
import { stringify } from 'querystring';
import type { ConnectState } from '@/models/connect';
import type { CurrentUser } from '@/models/auth';
// import { onMessageListener, setupNotifications } from '@/firebase';
import Cookies from 'js-cookie';
import { getProfile } from '@/pages/Auth/auth';
import { setUserId } from '@/utils/utils';
import type { PartnerTourDataType } from '@/pages/Tour/tour.data';
import { Button, Modal } from 'antd';
// import useVisibilityChange from '@/useVisibilityChange';
// import { notification } from 'antd';

interface SecurityLayoutProps extends ConnectProps {
  loading?: boolean;
  currentUser?: CurrentUser;
}

const SecurityLayout: React.FC<SecurityLayoutProps> = (props) => {
  const { children, currentUser, dispatch, loading } = props;
  const [isReady, setReady] = useState(false);
  const { setInitialState } = useModel('@@initialState');

  const audioRef = useRef(null);

  const playAudio = () => {
    if (audioRef.current) {
      // @ts-ignore
      audioRef.current.play().catch((error: any) => {
        console.error('Playback error:', error);
      });
    }
  };

  const alertsBell = document.getElementById('alertsBell');

  // const isForeground = useVisibilityChange();
  // useEffect(() => {
  //   // setupNotifications();
  //
  //   onMessageListener()
  //     // .then((payload) => {
  //     .then(() => {
  //       if (alertsBell) {
  //         alertsBell.style.animation = 'ring .3s 2 ease';
  //       }
  //       playAudio();
  //       playAudio();
  //       // @ts-ignore
  //       document.getElementById('alertsBell').style.animation = 'ring .3s 2 ease';
  //       // notification.open({
  //       //   message: payload?.notification?.title,
  //       //   description: payload?.notification?.body,
  //       //   onClick: () => {
  //       //     console.log('Notification Clicked!');
  //       //   },
  //       // });
  //     })
  //     .catch((err) => console.log('failed: ', err));
  // }, []);

  const isWebView = () => {
    // @ts-ignore
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const isIOSWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(userAgent);
    const isAndroidWebView =
      /Version\/[\d.]+.*Chrome\/[\d.]+ Mobile/i.test(userAgent) && !/Safari/i.test(userAgent);

    return isIOSWebView || isAndroidWebView;
  };

  useEffect(() => {
    if (isWebView()) {
      document.body.classList.add('webview');
    }

    setReady(true);
    setLocale('vi-VN');
    if (dispatch) {
      dispatch({
        type: 'auth/getProfile',
      });
    }
  }, [dispatch]);
  //
  useEffect(() => {
    if (currentUser) {
      setInitialState({ currentUser });
    }
  }, [currentUser, setInitialState]);

  const searchParams = new URLSearchParams(window.location.search);

  const accessToken = searchParams.get('access_token');

  useEffect(() => {
    if (accessToken) {
      Cookies.set('access-token', accessToken);
      localStorage.setItem('access-token', accessToken);

      getProfile().then((r) => {
        setUserId(r.id);
      });
    }
  }, [accessToken]);
  //
  // // You can replace it to your authentication rule (such as check token exists)
  const isLogin = currentUser && currentUser.id;
  const queryString = stringify({
    redirect: window.location.href,
  });

  const [open, setOpen] = useState<boolean>(localStorage.getItem('show-banner') == '1');

  if ((!isLogin && loading) || !isReady) {
    return (
      <>
        <PageLoading />
      </>
    );
  }

  if (!isLogin && window.location.pathname !== '/auth/login' && !accessToken) {
    return <Redirect to={`/auth/login?${queryString}`} />;
  }

  return (
    <>
      {isWebView() && <audio ref={audioRef} src="/telegram_notification.mp3" />}
      {children}
      <Modal
        bodyStyle={{ padding: 0, marginTop: '80px' }}
        open={open}
        width={700}
        footer={null}
        onCancel={() => {
          localStorage.setItem('show-banner', '0');
          setOpen(false);
        }}
      >
        <img src="/banner.jpg" alt="" style={{ width: '700px' }} />
        <Button
          style={{
            color: '#fff',
            background: 'rgba(3, 191, 167, 1)',
            border: '1px solid rgba(245, 245, 245, 1)',
            borderRadius: '40px',
            position: 'absolute',
            bottom: '40px',
            right: '100px',
          }}
        >
          <a
            rel="noreferrer"
            target={'_blank'}
            href="https://drive.google.com/file/d/1eHF7xM-3FlvOVXn9QIifk8SD6yx6ddoj/view"
          >
            Xem chi tiết
          </a>
        </Button>
      </Modal>
    </>
  );
};

export default connect(({ auth, loading }: ConnectState) => ({
  currentUser: auth.user,
  loading: loading.models.auth,
}))(SecurityLayout);
